export class ContentError extends Error {
  readonly message: string
  readonly type: string
  constructor(message: string) {
    super()
    this.type = 'ContentError'
    this.message = message
  }
}
